import { useState, useEffect } from 'react';
import Loader from "../Shared/Loader/Loader";
import APIConstant from "../../utils/pathConstants";
import api from "../../utils/apiClient";
import CommonConfig from '../../utils/constant';
import { TabView, TabPanel } from 'primereact/tabview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import userImage from '../../assets/images/UserImage.png';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { useCatchResponse } from '../../utils/useCatchResponse';
import { Calendar } from 'primereact/calendar';
import { apiBase } from '../../utils/config';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

const Attendance = () => {
    const navigate = useNavigate();
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [classList, setClassList] = useState([]);
    const [classWiseAttendanceList, setClassWiseAttendanceList] = useState([]);
    const [studentWiseAttendanceList, setStudentWiseAttendanceList] = useState([]);
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [selectedClass, setSelectedClass] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date);
    const [classTime, setClassTime] = useState('');
    const [isStudentView, setIsStudentView] = useState(false);
    const [attendanceList, setAttendanceList] = useState([]);
    const [childRows, setChildRows] = useState(10);
    const [childFirst, setChildFirst] = useState(0);
    const [selectedYear, setSelectedYear] = useState('');
    const [academicStartDate, setAcademicStartDate] = useState(null);
    const [academicEndDate, setAcademicEndDate] = useState(null);
    const loginData = CommonConfig.loginData();

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        getFinancialYearData(loginData);

    }, []);

    const getFinancialYearData = async (userData) => {
        const years = await CommonConfig.getFinancialYears(userData?.CreatedBy || userData?._id);
        const currentYear = CommonConfig.getCurrentFinancialYear(years);
        const selectedaYear = CommonConfig.getCookie('selectedAcademicYear');
        setSelectedYear(selectedaYear ?? currentYear?.value);
        await GetConfigurationData(CommonConfig.isOrgOwner(userData?.UserRole) ? userData?._id : (loginData?.CreatedBy || loginData?._id), years, selectedaYear ?? currentYear?.value);
        await GetClassList(CommonConfig.isOrgOwner(userData?.UserRole) ? userData?._id : (userData?.CreatedBy || userData?._id), selectedaYear ?? currentYear?.value);
    }

    const GetConfigurationData = async (id, academicYearList, academicYear) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetGeneralConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    if (res?.data?.IsAcademicYearApply) {
                        const academicCalendar = academicYearList || [];

                        if (!academicCalendar.length) {
                            setAcademicStartDate(null);
                            setAcademicEndDate(null);
                            return;
                        }

                        const validRanges = academicCalendar.filter(
                            item => item?.StartDate && item.EndDate && item?._id === academicYear
                        );

                        if (!validRanges.length) {
                            setAcademicStartDate(null);
                            setAcademicEndDate(null);
                            return;
                        }

                        const sortedCalendar = [...validRanges].sort(
                            (a, b) =>
                                new Date(a?.StartDate) - new Date(b?.StartDate)
                        );

                        const start = new Date(sortedCalendar[0]?.StartDate);
                        const end = new Date(sortedCalendar[0]?.EndDate);

                        setAcademicStartDate(start);
                        setAcademicEndDate(end);
                    }
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const onChildPageChange = (e) => {
        setChildFirst(e.first);
        setChildRows(e.rows);
    };

    const GetClassList = async (id, currentYear) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: currentYear
            }
            Loader.show();
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(res?.data?.filter(x => x?.Status === 'Active')?.map((x) => ({
                        value: x?._id,
                        label: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`
                    })));
                    if (res?.data.length) {
                        setSelectedClass(res?.data[0]?._id);
                        await GetClassWiseAttendanceList(res?.data[0]?._id, selectedDate, currentYear);
                        await GetStudentWiseAttendanceList(res?.data[0]?._id, selectedDate, currentYear);
                    }
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const formatDateToYMD = (dateObj) => {
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    };

    const GetClassWiseAttendanceList = async (id, date, financialId) => {
        try {
            let formattedDate = formatDateToYMD(date);
            let data = {
                ClassId: id,
                SelectedDate: formattedDate,
                FinancialYearId: financialId
            }
            Loader.show();
            await api.post(APIConstant.path.GetClassWiseAttendanceList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassWiseAttendanceList(res.data);
                }
                Loader.hide();
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetStudentWiseAttendanceList = async (id, date, financialId) => {
        try {
            let formattedDate = formatDateToYMD(date);
            let data = {
                ClassId: id,
                SelectedDate: formattedDate,
                FinancialYearId: financialId
            }
            Loader.show();
            await api.post(APIConstant.path.GetStudentWiseAttendanceList, data).then(async response => {
                let res = response;
                if (res.success) {
                    const sortedData = res.data.sort((a, b) => {
                        const rollA = parseInt(a?.RollNo) || 0;
                        const rollB = parseInt(b?.RollNo) || 0;

                        if (rollA !== rollB) {
                            return rollA - rollB;
                        }

                        const startTimeA = (a?.ClassTime || '').split(' - ')[0];
                        const startTimeB = (b?.ClassTime || '').split(' - ')[0];

                        const dateA = new Date(`1970-01-01 ${startTimeA}`);
                        const dateB = new Date(`1970-01-01 ${startTimeB}`);

                        return dateA - dateB;
                    });

                    setStudentWiseAttendanceList(sortedData);
                }
                Loader.hide();
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    function formatDate(dateString) {
        const date = new Date(dateString);
        const options = {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        };
        return date.toLocaleString('en-US', options).replace(',', '');
    }

    const attendanceDateBodyTemplate = (rows) => {
        return <div>{!CommonConfig.isEmpty(rows?.AttendanceDate) ? formatDate(rows?.AttendanceDate) : '--'}</div>
    };

    const attendanceBodyTemplate = (rows) => {
        return (
            <label htmlFor="attendance"
                style={{
                    color: rows?.AttendanceType === 'P' ? 'green' : rows?.AttendanceType === 'L' ? 'yellow' : 'red',
                    fontWeight: "bold",
                    cursor: "pointer",
                }}
            >
                {rows?.AttendanceType}
            </label>
        )
    };

    const attendanceActionBodyTemplate = (rows) => {
        return (
            <label htmlFor="attendance"
                style={{
                    color: '#1c515e',
                    fontWeight: "bold",
                    cursor: "pointer",
                }}
                onClick={() => {
                    setClassTime(rows?.ClassTime);
                    const attendanceData = studentWiseAttendanceList?.filter(y => y?.ClassTime === rows?.ClassTime && y?.SubjectName === rows?.SubjectName);
                    setAttendanceList(attendanceData);
                    setIsStudentView(true)
                }}
            >
                {rows?.AttendanceData || rows?.Attendance}
                {typeof rows?.TotalStudents === 'number' ? ` (${rows?.MarkedCount}/${rows?.TotalStudents} marked)` : ''}
            </label>
        )
    };

    const handleClassChange = (value) => {
        setSelectedClass(value);
        GetClassWiseAttendanceList(value, selectedDate, selectedYear);
        GetStudentWiseAttendanceList(value, selectedDate, selectedYear)
    }

    const handleDateChange = (value) => {
        setSelectedDate(value);
        GetClassWiseAttendanceList(selectedClass, value, selectedYear);
        GetStudentWiseAttendanceList(selectedClass, value, selectedYear)
    }

    const studentNameWithImageTemplate = (rowData) => {
        const imageUrl = rowData?.ProfilePic
            ? `${apiBase}/UserProfilePic/${rowData?.ProfilePic}`
            : userImage;

        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img
                    src={imageUrl}
                    alt={rowData.StudentName}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = userImage;
                    }}
                    style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                    }}
                />
            </div>
        );
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={() => {
                    setIsStudentView(false);
                    setClassTime('');
                    setAttendanceList([]);
                }}
            />
        </div>
    );

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    {loginData?.UserRole === 'Parent' && (
                        <i
                            className="pi pi-arrow-left back-arrow"
                            onClick={() => navigate('/childreen-list')}
                            style={{
                                fontSize: '1.2rem',
                                marginRight: '1rem',
                                cursor: 'pointer',
                                color: '#666'
                            }}
                        ></i>
                    )}
                    <i className="pi pi-eye"></i>
                    <h2>View Attendance</h2>
                </div>
                {loginData?.UserRole !== 'Parent' && (
                    <div className="p-grid p-align-center">
                        {/* <label htmlFor="attendanceDate">Attendance Date </label> */}
                        <div className='searchbar-area'>
                            <Calendar
                                className='p-w-100 p-mt-0'
                                id="attendanceDate"
                                value={selectedDate}
                                minDate={academicStartDate}
                                maxDate={academicEndDate}
                                hourFormat="12"
                                dateFormat="dd/mm/yy"
                                onChange={(e) => handleDateChange(e.value)}
                            />
                        </div>
                        <div>
                            <Dropdown
                                value={selectedClass}
                                options={classList}
                                onChange={(e) => handleClassChange(e.value)}
                                placeholder="Select Class"
                                filter showClear
                                style={{ height: '36px' }}
                            />
                        </div>
                    </div>)}
            </div>
            {loginData?.UserRole !== 'Parent' && (
                <div className='e-tab-main'>
                    <TabView>
                        <TabPanel header="Class Wise Attendance">
                            <div>
                                <DataTable
                                    value={classWiseAttendanceList}
                                    paginator
                                    rows={rows}
                                    first={first}
                                    filterDisplay="menu"
                                    responsiveLayout="scroll"
                                    paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                                    rowsPerPageOptions={[5, 10, 20]}
                                    currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                                    onPage={onPageChange}
                                    className='custom-table'
                                    scrollHeight='calc(100vh - 235px)'
                                    size='small'
                                >
                                    <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." />
                                    <Column
                                        field="ClassName"
                                        header="Class Name"
                                    />
                                    <Column
                                        field="ClassTime"
                                        header="Class Time"
                                    />
                                    <Column
                                        field="SubjectName"
                                        header="Subject Name"
                                    />
                                    <Column
                                        body={attendanceDateBodyTemplate}
                                        header="Submitted On"
                                    />
                                    <Column
                                        field='TakenBy'
                                        header="Submitted By"
                                    />
                                    <Column
                                        field='Attendance'
                                        header="Attendance"
                                        body={attendanceActionBodyTemplate}
                                    />
                                </DataTable>
                            </div>
                        </TabPanel>
                        <TabPanel header="Student Wise Attendance">
                            <div>
                                <DataTable
                                    value={studentWiseAttendanceList}
                                    paginator
                                    rows={rows}
                                    first={first}
                                    filterDisplay="menu"
                                    responsiveLayout="scroll"
                                    paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                                    rowsPerPageOptions={[5, 10, 20]}
                                    currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                                    onPage={onPageChange}
                                    className='custom-table'
                                    scrollHeight='calc(100vh - 280px)'
                                    size='small'
                                >
                                    <Column field="RollNo" header="Roll No." />
                                    <Column
                                        field="ClassName"
                                        header="Class Name"
                                    />
                                    <Column
                                        field="ClassTime"
                                        header="Class Time"
                                    />
                                    <Column
                                        field="SubjectName"
                                        header="Subject Name"
                                    />
                                    <Column header="Student Pic" body={studentNameWithImageTemplate} />
                                    <Column
                                        field="StudentName"
                                        header="Student Name"
                                    />
                                    <Column
                                        body={attendanceDateBodyTemplate}
                                        header="Submitted On"
                                    />
                                    <Column
                                        field='TakenBy'
                                        header="Submitted By"
                                    />
                                    <Column
                                        body={attendanceBodyTemplate}
                                        header="Attendance"
                                    />
                                </DataTable>
                            </div>
                        </TabPanel>
                    </TabView>
                </div>
            )}
            <Dialog
                header={attendanceList ? `${attendanceList[0]?.ClassName} (${attendanceList[0]?.SubjectName} - ${classTime})` : ''}
                visible={isStudentView}
                onHide={() => {
                    setIsStudentView(false);
                    setClassTime('');
                    setAttendanceList([]);
                }}
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
            >
                <div className="p-ai-center">
                    <DataTable
                        value={attendanceList}
                        paginator
                        rows={childRows}
                        first={childFirst}
                        filterDisplay="menu"
                        responsiveLayout="scroll"
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                        onPage={onChildPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 280px)'
                        size='small'
                    >
                        <Column
                            field="RollNo"
                            header="Roll No"
                        />
                        <Column header="Student Pic" body={studentNameWithImageTemplate} />
                        <Column
                            field="StudentName"
                            header="Student Name"
                        />
                        <Column
                            field="Attendance"
                            body={attendanceBodyTemplate}
                        />
                    </DataTable>
                </div>
            </Dialog>
        </div>
    );
};

export default Attendance;
